export enum ChatMessageDirection {
  Inbound,
  Outbound
}
